import React, {useState, useEffect} from 'react'
import PackingItemTable from './PackingItemTable'
import {getListPackingItem} from '../../../services/api/3dApi'
import {Link} from 'react-router-dom'
import {Icon, Pagination, Select, Button, Spin, message} from 'antd'
import FilterSelect from "../../shared/FilterSelect"
import SelectFilterOptions from "../../shared/SelectFilterOptions"
import {getListBrand, exportListPackingItem, getListPackingItemUsers} from '../../../services/api/3dApi'
import FilterDateRangeV2 from '../../shared/FilterDateRangeV2'
import FilterProductType from '../../batchesV3/components/filters/FilterProductType'
import downloadFileFromData from '../../../helpers/downloadFileFromData'
import moment from 'moment'
import * as storageService from '../../../services/StorageServices'
import { getUserList } from '../../../services/api/UserService'

function PackingItemPage() {
    const [error, setError] = useState('')
    const [total, setTotal] = useState(0)
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(50)
    const [listPackingItem, setListPackingItem] = useState([])
    const [listBrand, setListBrand] = useState([])
    const [brand, setBrand] = useState([])
    const [listUser, setListUser] = useState(storageService.getLocalData('packingItemUsers', []) || [])
    const [user, setUser] = useState([])
    const [type, setType] = useState([])
    const [packagedAt, setPackagedAt] = useState({})
    const [loading, setLoading] = useState(false)

    const fetchPackingItem = async () => {
        setLoading(true)
        try {
            const payload = {
                page: page,
                limit: limit,
            }
            if (brand.length) payload.brand = brand
            if (user.length) payload.user = user
            if (type.length) payload.sku = type
            if (Object.keys(packagedAt).length) {
                payload['packaged_at[from]'] = packagedAt.from
                payload['packaged_at[to]'] = packagedAt.to
            }

            const {data: res} = await getListPackingItem(payload)
            const {data, success, message: mess} = {...res}
            if (success) {
                setListPackingItem(data.barcodes)
                setTotal(data.total)
                setPage(data.page)
                setLimit(data.limit)
            } else {
                setError(mess)
                message.error(mess)
            }
        } catch (error) {
            setError(error.message)
            message.error(error.message)
        } finally {
            setLoading(false)
        }
    }

    const fetchUsers = async () => {
        try {
            const {data: res} = await getListPackingItemUsers()
            const raw = res && res.data
            const list = Array.isArray(raw) ? raw : (raw && (raw.users || raw.data)) || []
            const users = list
                .map(i => (typeof i === 'string' ? {username: i} : i))
                .filter(i => i && i.username)
            if (res && res.success && users.length) {
                storageService.setLocalData('packingItemUsers', users)
                setListUser(users)
                return
            }
            const {data, success} = await getUserList({page: 1, limit: 10000, is_active: true})
            if (success) setListUser(data.users)
        } catch (error) {
            console.log(error)
        }
    }

    const _getListBrand = async () => {
        const payload = {
            limit: 10000,
            page: 1
        }
        try {
            const {data: Data} = await getListBrand(payload)
            const {data, success, message} = Data
            const Brands = data.Brands.map(i => ({value: i.name, label: i.name}))
            if (success) {
                setListBrand(Brands)
            } else {
                console.log(message)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const handleChangeBrand = (value) => {
        setBrand(value)
        setPage(1)
    }

    const handleChangeUser = (field, value) => {
        setUser(value || [])
        setPage(1)
    }

    const handleChangeType = (value) => {
        setType(value)
        setPage(1)
    }
    const handleChangePackagedAt = (field, value) => {
        setPackagedAt(value)
        setPage(1)
    }

    const exportPackingItem = async () => {
        setLoading(true)
        setError('')

        try {
            const payload = {
                page: page,
                limit: limit,
            }
            if (brand.length) payload.brand = brand
            if (user.length) payload.user = user
            if (type.length) payload.sku = type
            if (Object.keys(packagedAt).length) {
                payload.packaged_at = packagedAt
            }

            const {data} = await exportListPackingItem(payload)

            if (data) {
                downloadFileFromData(data, {filename: `packing-items-${moment().format('YYYY-MM-DD-HH-mm-ss')}.csv`})
            }

            setLoading(false)

        } catch (e) {
            setError(e.message)
            setLoading(false)
        }
    }

    const handlePageChange = (current) => {
        setPage(current)
    }

    const handleShowSizeChange = (current, size) => {
        setPage(1)
        setLimit(size)
    }

    useEffect(() => {
        fetchPackingItem()
    }, [brand, user, type, packagedAt, limit, page])

    useEffect(() => {
        fetchUsers()
        _getListBrand()
    }, [])

    const {Option} = Select
    const disableNoBrand = !!brand && brand.length > 0 && !brand.includes('no brand')
    const disableOptionBrand = !!brand && brand.length > 0 && brand.includes('no brand')
    const listuser = (listUser || []).map(i => ({
        value: i.username,
        name: i.username,
    }))
    // đảm bảo người đang lọc (vd bấm từ cột Người đóng gói) luôn có trong option
    user.filter(u => !listuser.some(i => i.value === u)).forEach(u => listuser.unshift({value: u, name: u}))

    return (
        <div className='PackingItemPage'>
            <div className='container-fluid min-vh-100'>
                <div className='col-12 mx-auto bg-white shadow-sm py-3'>
                    <div className='mb-3 d-flex justify-content-between mt-3'>
                        <h3 className='mb-0'>Danh sách item đóng gói</h3>
                        <div className='d-flex align-items-center'>
                            <Button
                                className='ant-btn ant-btn-primary ml-3'
                                onClick={exportPackingItem}
                                disabled={loading}
                            >
                                Export
                            </Button>
                            <Link
                                className='ant-btn ml-3'
                                to='orders/packing'
                                disabled={loading}
                            >
                                Đánh dấu đóng gói
                            </Link>
                        </div>
                    </div>
                    <div className='jumbotron p-3 mb-3'>
                        <div className='row align-items-start'>
                            <div className='col-12 col-xl-4'>
                                <label className='font-weight-bold mb-1'>Loại sản phẩm:</label>
                                <FilterProductType
                                    productTypes={type}
                                    onChangeProductType={handleChangeType}
                                />
                            </div>

                            <div className='col-12 col-xl-2'>
                                <label for="request_update"
                                       className="d-block w-100 font-weight-bold mb-1">Brand</label>
                                <Select
                                    name='brand'
                                    className='brand'
                                    mode={'multiple'}
                                    onChange={(value) => handleChangeBrand(value)}
                                    value={brand}
                                    allowClear
                                    showArrow
                                    placeholder='Chọn brand name'
                                    style={{width: '100%'}}
                                >
                                    <Option disabled={disableNoBrand} value='no brand'> No brand</Option>
                                    {listBrand.length && listBrand.map((i, index) => (
                                        <Option disabled={disableOptionBrand} value={i.value}
                                                key={index}>{i.label}</Option>
                                    ))
                                    }
                                </Select>
                            </div>
                            <div className='col-12 col-xl-auto'>
                                <div className='font-weight-bold mb-1'>Người đóng gói: </div>
                                <SelectFilterOptions
                                    listOptions={listuser || []}
                                    value={user}
                                    field='user'
                                    mode="multiple"
                                    handleChange={handleChangeUser}
                                    allowClear={true}
                                    placeholder="Chọn người đóng gói"
                                    style={{width: 300}}
                                />
                            </div>
                            <div className='col-12 col-xl-auto'>
                                <label className="font-weight-bold mb-1">Thời gian đóng gói</label>
                                <FilterDateRangeV2
                                    field='packaged_at'
                                    onDatesChange={handleChangePackagedAt}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mb-3 headPagination">
                        <div>
                            {error && <div className='text-danger'>{error}</div>}
                        </div>
                        <Pagination
                            current={page}
                            total={total}
                            pageSize={limit}
                            className='text-right' showSizeChanger
                            pageSizeOptions={['10', '20', '50', '100']}
                            showTotal={(sum, range) => sum > 0 &&
                                <div>
                                    {`Hiển thị ${range[0]} đến ${range[1]} của `}<strong>{`${total} lô hàng`}</strong>
                                </div>}
                            onChange={handlePageChange}
                            onShowSizeChange={handleShowSizeChange}
                            disabled={loading}
                        />
                    </div>
                    <Spin spinning={loading} tip='Loading...'>
                        <PackingItemTable
                            listPackingItem={listPackingItem}
                            setType={setType}
                            setBrand={setBrand}
                            setUser={(value) => handleChangeUser('user', [value])}
                        />
                    </Spin>
                    <Pagination
                        current={page}
                        total={total}
                        pageSize={limit}
                        className='text-right'
                        showSizeChanger
                        showQuickJumper
                        pageSizeOptions={['10', '20', '50', '100']}
                        onChange={handlePageChange}
                        onShowSizeChange={handleShowSizeChange}
                        disabled={loading}
                    />
                </div>
            </div>
        </div>
    )
}

export default PackingItemPage